<template>
  <div class="message-history">
    <div class="accordeon">
      <div 
        class="accordeon-header" 
        v-b-toggle="'collapse-history-'+accordeonName"
      >
        Forwarded messages
        <span class="reply-count">{{messages.length}}</span>
      </div>
      <b-collapse :id="'collapse-history-'+accordeonName" :visible="false">
        <div class="history-item" v-for="message in messages" :key="message.id">
          <div class="history-item__heading" v-b-toggle="'history-item-'+accordeonName+message.id">
            
            <svg width="12" height="12" class="arrow-button" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.76496 4.69531C2.49769 4.69531 2.36384 5.01846 2.55283 5.20744L5.82857 8.48318C5.94573 8.60034 6.13568 8.60034 6.25283 8.48318L9.52856 5.20744C9.71755 5.01845 9.5837 4.69531 9.31643 4.69531H2.76496Z" fill="#2C2C2C"/>
            </svg>
            <div class="text-block">
              <div class="email-from">
                {{message.email_from}}
                <svg class="file-icn" v-if="message.files.length != 0" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 15.5C5.24268 15.5 3 13.3975 3 10.8125L3 4.25C3 3.90439 3.29871 3.62504 3.66663 3.62504C4.03467 3.62504 4.33337 3.90439 4.33337 4.25L4.33337 10.8125C4.33337 12.7075 5.97803 14.25 8 14.25C10.022 14.25 11.6666 12.7075 11.6666 10.8125V3.93746C11.6666 2.73125 10.62 1.75004 9.33337 1.75004C8.04663 1.75004 7 2.73125 7 3.93746V10.1875C7 10.7044 7.44861 11.125 8 11.125C8.55139 11.125 9 10.7044 9 10.1875V4.25C9 3.90439 9.29871 3.62504 9.66663 3.62504C10.0347 3.62504 10.3334 3.90439 10.3334 4.25V10.1875C10.3334 11.3937 9.28662 12.375 8 12.375C6.71338 12.375 5.66663 11.3937 5.66663 10.1875V3.93746C5.66663 2.04255 7.31128 0.5 9.33337 0.5C11.3553 0.5 13 2.04255 13 3.93746V10.8125C13 13.3975 10.7573 15.5 8 15.5Z" fill="#787F89"/>
                </svg>
                <span class="message-date">{{message.created_at | formatDateAndTimeSpace}}</span>
              </div>
              <div class="hide-accordeon-text">Hide message details</div>
              <span class="email-subject">{{getMessageText(message)}}</span>
            </div>
            <button class="del-btn" v-if="messages.length > 1" @click.stop="$emit('deleteForwardedItem', message.id)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6364 4.36585C10.5073 4.36585 10.4091 4.46907 10.4091 4.58852V5.26399H13.5909V4.58852C13.5909 4.46907 13.4927 4.36585 13.3636 4.36585L10.6364 4.36585ZM14.9545 5.26399V4.58852C14.9545 3.70768 14.2387 3 13.3636 3L10.6364 3C9.76125 3 9.04545 3.70768 9.04545 4.58852V5.26399H5.18182C4.80526 5.26399 4.5 5.56975 4.5 5.94692C4.5 6.32409 4.80526 6.62984 5.18182 6.62984H6.31818V16.5059C6.31818 17.8869 7.441 19 8.81818 19H15.1818C16.559 19 17.6818 17.8869 17.6818 16.5059V6.62984H18.8182C19.1947 6.62984 19.5 6.32409 19.5 5.94692C19.5 5.56975 19.1947 5.26399 18.8182 5.26399H14.9545ZM7.68182 6.62984V16.5059C7.68182 17.1255 8.18706 17.6341 8.81818 17.6341H15.1818C15.8129 17.6341 16.3182 17.1255 16.3182 16.5059V6.62984H7.68182ZM10.6364 8.88637C11.0129 8.88637 11.3182 9.19213 11.3182 9.5693V14.5501C11.3182 14.9272 11.0129 15.233 10.6364 15.233C10.2598 15.233 9.95455 14.9272 9.95455 14.5501V9.5693C9.95455 9.19213 10.2598 8.88637 10.6364 8.88637ZM13.3636 8.88637C13.7402 8.88637 14.0455 9.19213 14.0455 9.5693V14.5501C14.0455 14.9272 13.7402 15.233 13.3636 15.233C12.9871 15.233 12.6818 14.9272 12.6818 14.5501V9.5693C12.6818 9.19213 12.9871 8.88637 13.3636 8.88637Z" fill="#9AA3B0"/>
              </svg>
            </button>

          </div>
            <b-collapse :id="'history-item-'+accordeonName+message.id" :visible="false">
              <div class="mail-info-block">
                <div class="mail-info-block__row">
                  <span class="name">From:</span>
                  <span class="text">{{message.email_from || '-'}}</span>
                </div>
                <div class="mail-info-block__row">
                  <span class="name">To:</span>
                  <div class="text-block">
                    <span class="text-block__item">{{message.email_to_info ? message.email_to_info.join(', ') : message.email_to.join(', ')}}</span>
                  </div>
                </div>
                <div class="mail-info-block__row" v-if="Array.isArray(message.email_to_cc) == true &&  message.email_to_cc.filter(a=> a !== '').length">
                  <span class="name">CC:</span>
                  <div class="text-block">
                    <span class="text-block__item crop">{{message.email_to_cc.filter(a=> a !== '').join(', ')}}</span>
                  </div>
                </div>
                <div class="mail-info-block__row">
                  <span class="name">Sent:</span>
                  <span class="text">{{message.created_at | formatDateAndTimeSpace2}}</span>
                </div>
                <div class="files-block">
                  <a download target="_blank" :href="file.file" class="file" v-for="(file, index) in message.files" :key="index">
                    <div class="file-img"></div>
                    <span class="file-name">{{file.name || '-'}}</span>
                    <span class="file-size">{{file.size || 0}}</span>
                  </a>
                </div>
              </div>
            <!-- <div class="history-item__text" v-html="message.text"></div> -->
            <div class="history-item__text" v-html="getMailText(message)"></div>
          </b-collapse>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'messageHistory',
    props: {
      vesselMode: Boolean,
      messages: [Array, Object],
      accordeonName: [String]  //Чтобы аккордеоны не открывались одновременно
    },
    methods: {
      // Get text for accordeon heading
      getMessageText(message){
        const container = document.createElement('div');
        container.innerHTML = message.text;
        container.querySelectorAll('style').forEach(
          style => style.remove()
        );
        container.querySelectorAll('meta').forEach(
          meta => meta.remove()
        );
        return container.innerText.replace(/\n/g, '')
      },
      // Get text to body (vs draft)
      getMailText(mail){
        const container = document.createElement('div');
        container.innerHTML = mail.text;
        let draftText = container.querySelector('.draft-text')
        container.querySelectorAll('style').forEach(
          style => style.remove()
        );
        container.querySelectorAll('meta').forEach(
          meta => meta.remove()
        );
        // Если письмо сохранили в черновик, исправили, добавили в архив и хотят отправить - добавить текст из черновика
        if(draftText){
          let text = draftText.innerHTML
          draftText.remove()
          return text + container.innerHTML
        }else{
          return container.innerHTML;
        }

      }
    }
  }
</script>

<style lang="scss" scoped>
.message-history{
  .accordeon-header{
    height: 37px;
    border-top: 1px solid var(--color-gray-dark);
    border-bottom: 1px solid var(--color-gray-dark);
    display: flex;
    align-items: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-left: 16px;
    
    .reply-count{
      margin-left: 8px;
      display: flex;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      background: var(--color-blue-gray-list);
      color: var(--color-blue-dark);
      padding: 2px 6px;
      border-radius: 50%;
    }
    &:hover{
      cursor: pointer;
    }
  }
  .accordeon-content{
    max-width: 100%;
    padding: 16px 4px;
    /deep/{
      strong{
        font-weight: bold;
        &.date-text{
          font-weight: normal;
          font-size: 13px;
          color: #9AA3B0;
        }
      }
      em{
        font-style: italic;
      }
      .ql-align-center{
        text-align: center;
      }
      .ql-align-right{
        text-align: right;
      }
      .ql-align-justify{
        text-align: justify;
      }
      blockquote{
        padding: 10px !important;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        background-color: var(--color-white-dark);
        border-left: 3px solid var(--color-gray);
        margin-bottom: 10px !important;
        margin-top: 10px !important;
      }
      .ql-syntax, pre{
        background: var(--color-dark);
        color: var(--color-yellow);
        padding: 4px;
        border-radius: 4px;
        width: fit-content;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      ol{
        padding-left: 16px;
        li{
          list-style-type: decimal;
        }
      }
      ul{
        padding-left: 16px;
        li{
          list-style-type: disc;
        }
      }
      pre{
        max-width: 100%;
        word-wrap: break-word;
        white-space: pre-wrap;
      }
      // p{
      //   white-space: pre-wrap;
      // }
      @for $i from 1 to 9{
        $paddingLeft: $i * 10 + '%';
        .ql-indent-#{$i}{
          padding-left: #{$paddingLeft};
        }
      }
      h1{font-size: 2em;}
      h2{font-size: 1.5em;}
      h3{font-size: 1.17em}
      h4{font-size: 1em;}
      h5{font-size: .83em;}
      h6{font-size: .67em;}
      
    }
  }
  .history-item{
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--color-gray-dark);
  }
  .history-item__heading{
    display: flex;
    align-items: center;
    padding-left: 12px;
    padding-top: 16px;
    padding-bottom: 16px;
    .arrow-button{
      min-width: 12px;
      min-height: 12px;
    }
    &.not-collapsed{
      .arrow-button{
        transform: rotate(180deg);
      }
    }
    &:hover{
      cursor: pointer;
    }
    .text-block{
      display: flex;
      flex-direction: column;
      row-gap: 4px;
      padding-left: 8px;
      width: 100%;
      max-width: 95%;
    }
    .del-btn{
      margin-left: auto;
      svg{
        path{
          transition: .3s;
        }
      }
      &:hover{
        svg{
          path{
            fill: var(--color-blue-dark);
            transition: .3s;
          }
        }
      }
    }
    .email-from{
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      display: flex;
      justify-content: space-between;
      .message-date{
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: var(--color-new-dark-gray);
        padding-right: 8px;
      }
      .file-icn{
        margin-right: auto;
      }
    }
    .email-subject{
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 95%;
    }
    .hide-accordeon-text{
      display: none;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
    &.not-collapsed{
      .email-from, .email-subject{
        display: none;
      }
      .hide-accordeon-text{
        display: flex;
      }
    }
  }
  .history-item__text{
    padding-left: 32px;
    padding-bottom: 16px;
    max-width: 600px;
    /deep/{
      strong{
        font-weight: bold;
        &.date-text{
          font-weight: normal;
          font-size: 13px;
          color: #9AA3B0;
        }
      }
      em{
        font-style: italic;
      }
      .ql-align-center{
        text-align: center;
      }
      .ql-align-right{
        text-align: right;
      }
      .ql-align-justify{
        text-align: justify;
      }
      blockquote{
        padding: 10px !important;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        background-color: var(--color-white-dark);
        border-left: 3px solid var(--color-gray);
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .ql-syntax, pre{
        background: var(--color-dark);
        color: var(--color-yellow);
        padding: 4px;
        border-radius: 4px;
        width: fit-content;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      ol{
        padding-left: 16px;
        li{
          list-style-type: decimal;
        }
      }
      ul{
        padding-left: 16px;
        li{
          list-style-type: disc;
        }
      }
      @for $i from 1 to 9{
        $paddingLeft: $i * 10 + '%';
        .ql-indent-#{$i}{
          padding-left: #{$paddingLeft};
        }
      }
      h1{font-size: 2em;}
      h2{font-size: 1.5em;}
      h3{font-size: 1.17em}
      h4{font-size: 1em;}
      h5{font-size: .83em;}
      h6{font-size: .67em;}
      pre{
        max-width: 100%;
        word-wrap: break-word;
        white-space: pre-wrap;
      }
    }
  }
  &.hide-del-btn{
    .history-item__heading{
      .del-btn{
        display: none;
      }
    }
  }
  .mail-info-block{
    margin-bottom: 16px;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    background: var(--color-gray-lightest);
    row-gap: 4px;
    .mail-info-block__row{
      display: flex;
      align-items: flex-start;
      column-gap: 12px;
      .name{
        width: 35px;
        min-width: 35px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: var(--color-gray-text);
      }
      .text-block{
        display: flex;
        flex-wrap: wrap;
        column-gap: 4px;
        row-gap: 4px;
      }
      .text, .text-block__item{
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
  .files-block{
    padding-top: 8px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 8px;
    row-gap: 8px;
    .file{
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 2px;
      width: 66px;
      min-width: 66px;
      .file-name{
        padding-top: 2px;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline;
        max-width: 100%;
        color: var(--color-dark);
      }
      .file-size{
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: var(--color-gray-text);
      }
      .file-img{
        background-image: url("data:image/svg+xml,%3Csvg width='40' height='48' viewBox='0 0 40 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3 48H37C38.6569 48 40 46.6569 40 45V13L27 0H3C1.34315 0 0 1.34315 0 3V45C0 46.6569 1.34315 48 3 48Z' fill='%23DEE3EA'/%3E%3Cpath d='M12.9506 31.6148L19.4913 12V28.2712C19.4913 28.5016 19.3571 28.7106 19.1485 28.8052L12.9506 31.6148Z' fill='%239AA3B0'/%3E%3Cpath d='M27.0494 31.6148L20.5087 12V28.2712C20.5087 28.5016 20.6429 28.7106 20.8515 28.8052L27.0494 31.6148Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.6601 17.2724C12.789 17.942 8.22674 22.9613 8.22674 29.0532C8.22674 31.1083 8.74562 33.0403 9.65843 34.7247L19.2353 30.1223V30.9274L9.36213 35.6754L9.19424 35.3854C8.11702 33.525 7.5 31.3611 7.5 29.0532C7.5 22.5847 12.344 17.2562 18.5783 16.5451L18.6601 17.2724ZM31.7733 29.0532C31.7733 22.9613 27.211 17.942 21.3399 17.2724L21.4217 16.5451C27.656 17.2562 32.5 22.5847 32.5 29.0532C32.5 31.3611 31.883 33.525 30.8058 35.3854L30.6359 35.6788L20.7647 30.9412L20.7544 30.1223L30.3435 34.7212C31.2551 33.0376 31.7733 31.1068 31.7733 29.0532Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 33.5294L10.963 37.5732L10.6471 36.9141L19.2353 32.7059V33.5294Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 35.8823L12.6619 39.1399L12.3478 38.4798L19.2353 35.0772V35.8823Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 38.2243L14.2608 40.75L13.9466 40.09L19.2353 37.4192V38.2243Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 33.5294L29.2674 37.5292L29.5833 36.8701L20.7647 32.7059V33.5294Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 35.8823L27.7422 39.1399L28.0562 38.4798L20.7647 35.0772V35.8823Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 38.2243L26.1433 40.75L26.4574 40.09L20.7647 37.4192V38.2243Z' fill='%239AA3B0'/%3E%3Cpath d='M40 13L30 13C28.3431 13 27 11.6569 27 10L27 -1.82822e-07L32.881 5.98L40 13Z' fill='%23BDCBD6'/%3E%3C/svg%3E%0A");
        background-size: cover;
        background-position: center;
        width: 40px;
        height: 48px;
      }
    }
  }
}
.max-width-600{
  max-width: 600px;
}
</style>